import { Routes } from '@angular/router';

import {
  getAggregatedDataResolver,
  getAnalyticalDataResolver,
  getDataWindowResolver,
  getEngagementDataResolver,
  getEvolutionDataResolver,
  getManagementDiaryDataResolver,
  getMeterDataResolver,
  getReservationDataResolver,
  getSummaryDataResolver,
  getWordcloudDataResolver,
} from './get-data.resolver';
import { PrintAnalyticalComponent } from './print-analytical/print-analytical.component';
import { PrintAggregatedComponent } from './print-aggregated/print-aggregated.component';
import { PrintDocumentComponent } from './print-document.component';
import { PrintEngagementComponent } from './print-engagement/print-engagement.component';
import { PrintEvolutionComponent } from './print-evolution/print-evolution.component';
import { PrintManagementDiaryComponent } from './print-management-diary/print-management-diary.component';
import { PrintMeterComponent } from './print-meter/print-meter.component';
import { PrintSummaryComponent } from './print-summary/print-summary.component';
import { PrintWordCloudComponent } from './print-word-cloud/print-word-cloud.component';
import { PrintIncentiveComponent } from "./print-incentive/print-incentive.component";
import { PrintReservationComponent } from './print-reservation/print-reservation.component';
import { PrintShiftComponent } from './print-shift/print-shift.component';

export const PrintDocumentsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => PrintDocumentComponent,
    children: [
      {
        path: 'summary',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintSummaryComponent,
      },
      {
        path: 'aggregated/:pollId',
        resolve: {
          data: getAggregatedDataResolver,
        },
        loadComponent: () => PrintAggregatedComponent,
      },
      {
        /**
         * Exemplo de url
         * Com varions params {branchesId, startDate, finishDate, branchesName}
         http://localhost:4200/print/summary/fa9b600b-7aaf-473e-a8a6-e83557353df5?branchesId=db9cd15a-675a-4fce-9e06-bfd3eae2e1dc,245ed0e5-6d6d-4229-94a3-dfb64bad169d&startDate=2025-01-05T03:00:00.000Z&finishDate=2025-02-04T03:00:00.000Z&branchesName=0002 - EQUIPESCA,3733 - ABB
         */
        path: 'summary/:pollId',
        resolve: {
          data: getSummaryDataResolver,
        },
        loadComponent: () => PrintSummaryComponent,
      },
      {
        path: 'managementDiary',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintManagementDiaryComponent,
      },
      {
        /**
         http://localhost:4200/print/managementDiary/fa9b600b-7aaf-473e-a8a6-e83557353df5?branchesId=db9cd15a-675a-4fce-9e06-bfd3eae2e1dc,245ed0e5-6d6d-4229-94a3-dfb64bad169d&startDate=2024-11-01T03:00:00.000Z&finishDate=2025-02-04T03:00:00.000Z&branchesName=0002%20-%20EQUIPESCA,3733%20-%20ABB
         */
        path: 'managementDiary/:pollId',
        resolve: {
          data: getManagementDiaryDataResolver,
        },
        loadComponent: () => PrintManagementDiaryComponent,
      },
      {
        path: 'engagement',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintEngagementComponent,
      },
      {
        /**
         http://localhost:4200/print/engagement/fa9b600b-7aaf-473e-a8a6-e83557353df5?branchesId=db9cd15a-675a-4fce-9e06-bfd3eae2e1dc,245ed0e5-6d6d-4229-94a3-dfb64bad169d&startDate=2024-03-06T03:00:00.000Z&finishDate=2025-02-04T03:00:00.000Z&branchesName=0002%20-%20EQUIPESCA,3733%20-%20ABB
         */
        path: 'engagement/:pollId',
        resolve: {
          data: getEngagementDataResolver,
        },
        loadComponent: () => PrintEngagementComponent,
      },
      {
        path: 'evolution',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintEvolutionComponent,
      },
      {
        /**
         http://localhost:4200/print/evolution/fa9b600b-7aaf-473e-a8a6-e83557353df5?branchesId=db9cd15a-675a-4fce-9e06-bfd3eae2e1dc,245ed0e5-6d6d-4229-94a3-dfb64bad169d&startDate=2024-03-06T03:00:00.000Z&finishDate=2025-02-04T03:00:00.000Z&branchesName=0002%20-%20EQUIPESCA,3733%20-%20ABB
         */
        path: 'evolution/:pollId',
        resolve: {
          data: getEvolutionDataResolver,
        },
        loadComponent: () => PrintEvolutionComponent,
      },
      {
        path: 'analytical',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintAnalyticalComponent,
      },
      {
        /**
         http://localhost:4200/print/analytical/fa9b600b-7aaf-473e-a8a6-e83557353df5?branchesId=db9cd15a-675a-4fce-9e06-bfd3eae2e1dc,245ed0e5-6d6d-4229-94a3-dfb64bad169d&startDate=2025-01-06T03:00:00.000Z&finishDate=2025-02-05T03:00:00.000Z&branchesName=0002%20-%20EQUIPESCA,3733%20-%20ABB
         */
        path: 'analytical/:pollId',
        resolve: {
          data: getAnalyticalDataResolver,
        },
        loadComponent: () => PrintAnalyticalComponent,
      },
      {
        path: 'wordcloud',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintWordCloudComponent,
      },
      {
        /**
         http://localhost:4200/print/wordcloud/fa9b600b-7aaf-473e-a8a6-e83557353df5?branchesId=db9cd15a-675a-4fce-9e06-bfd3eae2e1dc,245ed0e5-6d6d-4229-94a3-dfb64bad169d&startDate=2025-01-06T03:00:00.000Z&finishDate=2025-02-05T03:00:00.000Z&branchesName=0002%20-%20EQUIPESCA,3733%20-%20ABB
         */
        path: 'wordcloud/:pollId',
        resolve: {
          data: getWordcloudDataResolver,
        },
        loadComponent: () => PrintWordCloudComponent,
      },
      {
        path: 'meter',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintMeterComponent,
      },
      {
        /**
         http://localhost:4200/print/meter/fa9b600b-7aaf-473e-a8a6-e83557353df5?branchesId=db9cd15a-675a-4fce-9e06-bfd3eae2e1dc,245ed0e5-6d6d-4229-94a3-dfb64bad169d&startDate=2024-03-07T03:00:00.000Z&finishDate=2025-02-05T03:00:00.000Z&branchesName=0002%20-%20EQUIPESCA,3733%20-%20ABB
         */
        path: 'meter/:pollId',
        resolve: {
          data: getMeterDataResolver,
        },
        loadComponent: () => PrintMeterComponent,
      },
      {
        /**
         http://localhost:4200/print/incentive?branchesId=38aa2ea2-b635-40a5-9c6c-3e5e1868786a&startDate=2025-05-30T03:00:00.000Z&finishDate=2025-07-18T03:00:00.000Z
         */
        path: 'incentive',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintIncentiveComponent
      },
      {
        path: 'reservation',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintReservationComponent
      },
      {
        /**
         * http://localhost:4200/print/reservation/fa9b600b-7aaf-473e-a8a6-e83557353df5?branchesId=...&startDate=...&finishDate=...&branchesName=...
         */
        path: 'reservation/:pollId',
        resolve: {
          data: getReservationDataResolver,
        },
        loadComponent: () => PrintReservationComponent
      },
      {
        path: 'shift',
        resolve: {
          data: getDataWindowResolver,
        },
        loadComponent: () => PrintShiftComponent
      },
    ],
  },
];
